<template>
  <div class="box13">
    <pageTitle title="免费课程" text />

    <commonFreeVideo pageName="ai2-就业课" class="box" :videoList="videoList" />

    <!-- <div class="btn" @click="toLink('https://m.boxuegu.com/')"> -->
    <div class="btn" @click="zixun('查看更多')">
      查看更多
      <span>></span>
    </div>
    <div class="bottom">
      大模型时代<br />
      做“站在风口上的”AI全栈工程师
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commonFreeVideo from "../common/common-free-video.vue";
export default {
  components: {
    pageTitle,
    commonFreeVideo,
  },
  data() {
    return {
      videoList: [
        {
          lessonName: "2小时搭建自己的聊天机器人",
          url: "https://www.boxuegu.com/course/detail-5597.html",

          img: require("../../../assets/coursePage/ai2/box14/img1.png"),
        },
        {
          lessonName: "爆火出圈的AIGC",
          url: "https://www.boxuegu.com/live/detail-5593.html",
          img: require("../../../assets/coursePage/ai2/box14/img2.png"),
        },
        {
          lessonName: "腾讯云AI绘画—StableDiffusion多模态模型的应用与开发",
          url: "https://www.boxuegu.com/course/detail-10042.html",
          img: require("../../../assets/coursePage/ai2/box14/img3.jpg"),
        },
        {
          lessonName: "数据科学与人工智能数学基础",
          url: "https://www.boxuegu.com/course/detail-1380.html",
          img: require("../../../assets/coursePage/ai2/box14/img4.png"),
        },
      ],
    };
  },
  methods: {
    zixun(name) {
      this.mai("AI大模型训练营", "查看更多", 0, null);
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box13 {
  padding: 80px 0px 0;
  width: 100%;
  background: url("../../../assets/coursePage/ai2/box14/bg2.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .box {
    margin-top: 48px;
  }
  .btn {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #165dff;
  }
  .bottom {
    background: url("../../../assets/coursePage/ai2/box14/bg.png") center center
      no-repeat;
    background-size: cover;
    height: 190px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #ffffff;
    line-height: 60px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
    padding-top: 36px;
    box-sizing: border-box;
    margin-top: 60px;
  }
}
</style>
